import { render, staticRenderFns } from "./DraftStaffPick.vue?vue&type=template&id=60840f54&"
import script from "./DraftStaffPick.vue?vue&type=script&lang=js&"
export * from "./DraftStaffPick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports